import dynamic from "next/dynamic";
import styles from "@styles/profile/profile.module.css";
const Members = dynamic(() => import("@components/community/Members"));
const UpvoteDialog = dynamic(() => import("@components/community/UpvoteDialog"), {
  ssr: false
});
const ProfileCompletionProgess = dynamic(() => import("@components/profile/CompletionDailog"), {
  ssr: false
});
export default function CommunityProfileSidebar({
  communityID,
  isAdmin,
  data,
  openEditCommunity
}) {
  return <div id={styles.profile_display_inner_right} className={styles.profile_display_inner_right} data-sentry-component="CommunityProfileSidebar" data-sentry-source-file="CommunityProfileSidebar.jsx">
      <div className={styles.profile_display_bottom}>
        {isAdmin && <ProfileCompletionProgess data={data} type="community" onClickHandler={openEditCommunity} />}
      </div>
      <UpvoteDialog smallScreen={false} communityID={communityID} communityTypeID={data?.typeID} isAdmin={isAdmin} upvotedStatus={data?.isUpvoted} upvoteNo={data?.CommunityMetric.upvoteNo} isUpvoting={data?.isUpvoting} data-sentry-element="UpvoteDialog" data-sentry-source-file="CommunityProfileSidebar.jsx" />
      <div className={styles.siderbar_members_container}>
        <Members communityID={communityID} isAdmin={isAdmin} data-sentry-element="Members" data-sentry-source-file="CommunityProfileSidebar.jsx" />
      </div>
    </div>;
}